// src/components/ContactBanner.tsx
import React from "react";
import "./ContactBanner.css";
import { ParallaxLayer } from "@react-spring/parallax";

const ContactBanner: React.FC<{ offset: number }> = ({ offset }) => {
	const openInNewTab = (url: string) => {
		window.open(url, "_blank", "noopener,noreferrer");
	};

	return (
		<ParallaxLayer
			key={`ContactBanner-${offset}`}
			offset={offset}
		>
			<div className="contact-banner">
				<button
					className="btn contact-btn"
					onClick={() => openInNewTab("https://www.bonkcoindao.com/")}
				>
					<span className="contactbanner-btn-text">Collab</span>
				</button>
				<button
					className="btn events-btn"
					onClick={() => openInNewTab("https://lu.ma/user/BONK")}
				>
					<span className="contactbanner-btn-text">Events</span>
				</button>
			</div>
		</ParallaxLayer>
	);
};

export default ContactBanner;
